<template>
  <Modal :showModal.sync="store.isBiometricLoginPromptOpen" :modal-class="'modal-dialog-centered fade-in-up px-3'"
         @click="closeBiometricLoginPrompt()">
    <div class="modal-content">

      <div class="modal-body p-4">

        <div class="h5 text-center my-4">{{ title }}</div>

        <button class="btn btn-block btn-lg btn-primary" @click="enableBiometricLogin()">{{
            $t('BiometricLoginPrompt.enable')
          }}
        </button>
        <button class="btn btn-block btn-lg btn-link"
                data-dismiss="modal"
                :aria-label="$t('BiometricLoginPrompt.close')"
                @click="closeBiometricLoginPrompt()">
          {{ $t('BiometricLoginPrompt.close') }}
        </button>
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from '@shared/components/Modal'
import store from '@shared/store'
import settings from '@shared/settings'

export default {
  name: 'BiometricLoginPrompt',
  components: { Modal },
  data() {
    return {
      store: store.state
    }
  },
  created() {
    this.$root.$once('biometric-login-enabled', this.onBiometricLoginEnabledEvent)
  },
  methods: {
    onBiometricLoginEnabledEvent() {
      this.$successToast(this.$t('AccountPage.biometricLoginEnabled'))
    },
    closeBiometricLoginPrompt() {
      store.closeBiometricLoginPrompt()
    },
    enableBiometricLogin() {
      store.closeBiometricLoginPrompt()
      this.$root.$emit('enable-biometric-login')
    }
  },
  computed: {
    title() {
      if (settings.isAndroid()) {
        return this.$t('BiometricLoginPrompt.title.android')
      } else if (settings.isIOS()) {
        return this.$t('BiometricLoginPrompt.title.ios')
      } else {
        return this.$t('BiometricLoginPrompt.title.default')
      }
    }
  }
}
</script>
